import React, { useState, useEffect, useContext } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import { GlobalContext } from "../../Context/GlobalContext";
import {
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CustomTableV2 from "../CustomTable/CustomTableV2";
import { f } from "../../utility/Formater";

function FilingStatusPopup({ isOpen, onClose }) {
  const { dealerDetailState, updateDocsState } = useContext(GlobalContext);
  const [dealerDetails, setDealerDetails] = dealerDetailState;
  
  let columns_filing_status = [
    {
      label: "Filing Year",
      render: (index) => {
        return f(dealerDetails?.gst_details?.filingStatus?.[index]?.filingYear);
      },
      width: 150,
    },
    {
      label: "Month Of Filing",
      render: (index) => {
        return f(dealerDetails?.gst_details?.filingStatus?.[index]?.monthOfFiling);
      },
      width: 150,
    },
    {
      label: "Method",
      render: (index) => {
        return f(dealerDetails?.gst_details?.filingStatus?.[index]?.methodOfFilling);
      },
      width: 150,
    },
    {
      label: "Date Of Filing",
      render: (index) => {
        return f(dealerDetails?.gst_details?.filingStatus?.[index]?.dateOfFiling);
      },
      width: 150,
    },
    {
      label: "GST Type",
      render: (index) => {
        return f(dealerDetails?.gst_details?.filingStatus?.[index]?.gstType);
      },
    },
    {
      label: "Status",
      render: (index) => {
        return f(dealerDetails?.gst_details?.filingStatus?.[index]?.gstStatus);
      },
    },
  ];
 
  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth sx={{width: "100%", px: 0 , pb:1}}>
      <DialogTitle>Dealer GSTIN - {dealerDetails?.gst_details?.gstin}</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: "gray",
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent>
      <CustomTableV2
            tableData={dealerDetails?.gst_details?.filingStatus}
            tableHeight={500}
            columns={columns_filing_status}
            limit={0}
            page={1}
            serialNo={false}
          />
      </DialogContent>
    </Dialog>
  );
}

export default FilingStatusPopup;
